import CSS from "./static/css/ProductInfoCardViewMode.module.css";
import MainInfoCard from "../../../../Component/Elements/MainInfoCard/MainInfoCard";
import { ProductDetail_SelectedOptionListEle_Interface, ProductDetail_SelectInformationDate_AddedInfo_Interface, ProductDetail_SelectInformationDate_Address_Interface } from "../../static/interface/ProductDetail.interface";
import LabelAndContent from "../../../../Component/Elements/LabelAndContent/LabelAndContent";
import SelectedOptionEle from "../SelectedOptionEle/SelectedOptionEle";
import BabyInfoView from "../BabyInfoView/BabyInfoView";
import EditRequestView from "../EditRequestView/EditRequestView";
import Hr from "../../../../Component/Elements/Hr/Hr";
import AddressInfoMain from "../AddressInfoMain/AddressInfoMain";
import { Dispatch, SetStateAction, useEffect } from "react";
import { dev_console } from "../../../../Common/ts/commonTools";

const ProductInfoCardViewMode = (
    {
        product_name,
        is_view_babyinfo,
        selectedOptionData,

        addedInfo,
        address_list,
        setAddressList,

        isRemoveOutline,

        isEditMode,

        productQty,
        totalAddressQty,
    }:{
        product_name: string;
        is_view_babyinfo?: boolean;
        selectedOptionData?: ProductDetail_SelectedOptionListEle_Interface[];

        addedInfo: ProductDetail_SelectInformationDate_AddedInfo_Interface | null;
        address_list: ProductDetail_SelectInformationDate_Address_Interface[];
        setAddressList: Dispatch<SetStateAction<ProductDetail_SelectInformationDate_Address_Interface[]>>;

        isRemoveOutline?: boolean;

        isEditMode: boolean;

        productQty: number;
        totalAddressQty: number;
    }
) => {
    return(
        <div
            className={CSS.l_ProductInfoCardViewMode_main}
            onClick={(event) => {
                event.stopPropagation();
            }}
        >
            <MainInfoCard
                title={product_name}
                isInnerComponent={isRemoveOutline}
            >
                {
                    selectedOptionData && selectedOptionData.length > 0
                    ?   <>
                            <LabelAndContent
                                label={"추가 옵션"}
                                flex_direction={"column"}
                                is_view_essential_icon={true}
                            >
                                <div className={CSS.l_ProductInfoCard_selectedOptionContainer}>
                                    {
                                        selectedOptionData && selectedOptionData.map((item) => {
                                            return(
                                                <SelectedOptionEle
                                                    key={item.option_id}
                                                    option_name={item.option_name}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            </LabelAndContent>

                            <Hr />
                        </>
                    :   null
                }

                {
                    is_view_babyinfo
                    ?   <>
                            <BabyInfoView
                                baby_name={addedInfo?.baby_name || ""}
                                baby_birth_day={addedInfo?.baby_birth_day || ""}
                                baby_birth_time={addedInfo?.baby_birth_time || ""}
                                baby_height={addedInfo?.baby_height || ""}
                                baby_weight={addedInfo?.baby_weight || ""}
                            />

                            <Hr />
                        </>
                    :   null
                }

                {
                    addedInfo?.common_memo
                    &&  <>
                            <EditRequestView
                                request={addedInfo?.common_memo || ""}
                            />

                            <Hr />
                        </>
                }

                {
                    address_list.map((item, index) => {
                        return(
                            <>
                                <AddressInfoMain
                                    key={index}
                                    address_index={index}
                                    view_mode={isEditMode ? "edit" : "view"}
                                    product_qty={productQty}
                                    total_address_qty={totalAddressQty}
                                    address_qty={item.product_qty}
                                    addressList={address_list}
                                    setAddressList={setAddressList}
                                />

                                {
                                    index < address_list.length
                                    &&  <Hr />
                                }
                            </>
                        )
                    })
                }
            </MainInfoCard>
        </div>
    )
}

export default ProductInfoCardViewMode;